import { ApiAuthenticationLoginUserGetRequest, ApiCertificazioneCellulareInviaSmsGetRequest, AuthenticationApi, CertificazioneApi, CertificazioneCellulareApi, CertificazioneCellulareUtenteDto, CertificazioneContattoDto, CertificazioneUtenteDto, Configuration, TokenDto } from '@desio/api';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkApiConfig } from 'store';
import getConfiguration, { errorHandler } from 'store/config';

export const setAccessTokenClienteAction = createAction<string, 'setAccessTokenClienteAction'>('setAccessTokenClienteAction');
export const resetAccessTokenClienteAction = createAction<void, 'resetAccessTokenClienteAction'>('resetAccessTokenClienteAction');

export const loginUserAction = createAsyncThunk<TokenDto | undefined, string, ThunkApiConfig>(
  'authentication/loginUser', async (tokenEmail, { dispatch, extra, getState }) => {
    try {
      if (extra.mock) {
        return (await import('../../../mock/post-login-admin-sso.json')).default;
      } else {
        const request: ApiAuthenticationLoginUserGetRequest = {
          tokenEmail
        };
        return await new AuthenticationApi(getConfiguration(Configuration, extra, getState, true)).apiAuthenticationLoginUserGet(request);
      }
    } catch (error) {
      errorHandler(error, dispatch);
    }
  }
);

export const getDettaglioCertificazioneClienteAction = createAsyncThunk<CertificazioneUtenteDto | undefined, undefined, ThunkApiConfig>(
  'certificazione/getDettaglioCertificazioneCliente', async (_, { dispatch, extra, getState }) => {
    try {
      if (extra.mock) {
        return (await import('../../../mock/dettaglio-certificazione-by-token.json')).default;
      } else {
        return await new CertificazioneApi(getConfiguration(Configuration, extra, getState, true)).apiCertificazioneDettaglioGet();
      }
    } catch (error) {
      errorHandler(error, dispatch);
    }
  }
);

export const inviaSmsCertificazioneClienteAction = createAsyncThunk<CertificazioneCellulareUtenteDto | undefined, undefined, ThunkApiConfig>(
  'certificazioneCellulare/inviaSmsCertificazioneCliente', async (_, { dispatch, extra, getState }) => {
    try {
      if (extra.mock) {
        return (await import('../../../mock/get-certifica-contatto.json')).default;
      } else {
        const request: ApiCertificazioneCellulareInviaSmsGetRequest = {
          timestamp: (new Date()).getTime()
        };
        return await new CertificazioneCellulareApi(getConfiguration(Configuration, extra, getState, true)).apiCertificazioneCellulareInviaSmsGet(request);
      }
    } catch (error) {
      errorHandler(error, dispatch);
    }
  }
);

export const certificazioneContattoClienteAction = createAsyncThunk<CertificazioneContattoDto | undefined, string, ThunkApiConfig>(
  'certificazione/certificazioneContattoCliente', async (tokenCellulare, { dispatch, extra, getState }) => {
    try {
      if (extra.mock) {
        //return (await import('../../../mock/get-certifica-contatto.json')).default;
      } else {
        return await new CertificazioneApi(getConfiguration(Configuration, extra, getState, true)).apiCertificazioneCertificaContattoGet({ tokenCellulare });
      }
    } catch (error) {
      errorHandler(error, dispatch);
    }
  }
);

